module.exports = __webpack_public_path__ + "img/PM_6.dd20421f.svg";